"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const config_1 = require("@completeanatomy/config");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function Motion(props) {
    const { image, text, isSelected, onClick } = props;
    const { t } = (0, i18n_1.useTranslation)();
    const config = (0, config_1.useConfigService)();
    const theme = (0, styled_components_1.useTheme)();
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const onLoad = () => {
        setIsLoaded(true);
    };
    const imageBaseUrl = (config === null || config === void 0 ? void 0 : config.get('AWS_SERVER_S3_USERDATA')) || '';
    return ((0, jsx_runtime_1.jsxs)(Container, { onClick: onClick, children: [!isLoaded && ((0, jsx_runtime_1.jsx)(StyledProgressBar, { children: (0, jsx_runtime_1.jsx)(ui_1.ProgressIndicator, { color: theme.grasshopper.loadingColor }) })), (0, jsx_runtime_1.jsx)(StyledImage, { src: imageBaseUrl + image, onLoad: onLoad, onError: onLoad }), (0, jsx_runtime_1.jsxs)(TextContainer, { children: [(0, jsx_runtime_1.jsx)(Text, { className: "motion-text", "$isSelected": isSelected, children: text }), (0, jsx_runtime_1.jsx)(Type, { children: t(i18n_1.Strings.search.tabs.motion).toUpperCase() })] })] }));
}
const StyledProgressBar = styled_components_1.default.div `
  position: absolute;

  margin-top: 35%;
`;
const Text = styled_components_1.default.div `
  display: flex;
  align-items: flex-end;

  font-size: 14px;
  line-height: 17px;

  height: 70%;

  padding: 8px;

  color: ${({ theme, $isSelected }) => $isSelected
    ? theme.grasshopper.text.white
    : theme.grasshopper.text.whiteSecondary};
`;
const Type = styled_components_1.default.div `
  display: flex;
  align-items: flex-end;

  font-size: 12px;
  line-height: 16px;

  height: 30%;

  padding: 8px;

  color: ${props => props.theme.grasshopper.text.whiteSecondary};
`;
const StyledImage = styled_components_1.default.img `
  width: 100%;
  height: 50%;

  margin: 0;

  border-radius: 8px 8px 0 0;
`;
const TextContainer = styled_components_1.default.div `
  font-family: 'Source Sans Pro';

  display: flex;
  flex-direction: column;

  font-size: 16px;

  color: ${props => props.theme.grasshopper.text.white};

  width: 100%;
  height: 50%;

  margin: 0;
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 216px;
  height: 296px;

  cursor: pointer;

  background: ${props => props.theme.designSystem.contentBackground};

  border-radius: 8px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.5));

  &:hover {
    .motion-text {
      color: ${({ theme }) => theme.grasshopper.text.white};
    }
  }
`;
exports.default = Motion;
